module.exports = __webpack_public_path__ + "d1ce6de39cf675eddda21918104241d9.MP3";